<template>
    <modal @hide="$emit('hide', $event)" @show="$emit('show', $event)" ref="modal" size="md">

        <div class="alert alert-warning" v-if="status">
            Oops! The integrated Google account is not allowed to respond. Please, verify you integration.
        </div>

        <div class="alert alert-danger" v-if="error">
            Oops! Internal server error. Try again or contact your system administrator.
        </div>

        <div slot="title">Reply Google Review</div>

        <div>
            <label>Reply</label>
            <textarea class="form-control" :maxlength="max" name="reply" v-model="form.reply"></textarea>
            <p class="invalid-feedback" v-if="form.errors.has('reply')">
                {{ form.errors.get('reply') }}
            </p>
            <div class="text-right mt-1">
                <span class="text-muted font-weight-light">
                    <small>{{ max - form.reply.length }} characters remaining</small>
                </span>
            </div>
        </div>

        <span slot="footer">
            <button type="button" class="btn btn-default" @click="close()">Cancel</button>
            <button-loading class="btn btn-primary" @click="save" :loading="form.submitting">Save</button-loading>
        </span>
    </modal>
</template>

<script>
    export default {
        name: "ReplyReviewGoogleModal",

        props: {
            review: { required: true }
        },

        data() {
            return {
                max    : 4096,
                form   : new Form({
                    id   : this.review.id,
                    reply: this.review.review_reply || ''
                }),
                status: false,
                error: false
            }
        },

        methods: {
            open() {
                this.$refs.modal.open();
            },

            close() {
                this.$refs.modal.close();
                this.status = false;
                this.error  = false;
            },

            save() {
                this.form.put(
                    this.$laroute.route('google-reviews-reply', {review: this.form.id})
                )
                .then(({data}) => {
                    if (data.status === 'error') {
                        this.status = true;
                        return;
                    }
                    this.$emit('replied');
                    this.$alert({
                        type: 'success',
                        title: 'Message successfully replied!'
                    });
                    this.close();
                })
                .catch((error) => {
                    this.error = true;
                })
            }
        }
    }
</script>
